/* LK BRINDES — assets/lk-brindes.js */
(function () {
  'use strict';
  if (window.__LKB__) return;
  window.__LKB__ = true;

  var cfgEl = document.getElementById('lk-brindes-config');
  if (!cfgEl) return;
  var CFG; try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var TIERS = (CFG.tiers || [])
    .filter(function (t) { return t && t.variants && t.variants.length && t.min > 0; })
    .sort(function (a, b) { return a.min - b.min; });
  if (!TIERS.length) return;

  var MODE = CFG.modo === 'cumulativo' ? 'cumulativo' : 'maior';
  var AVISO = (CFG.aviso || '').trim();
  var AUTO = CFG.auto !== false;
  var PROP = '_brinde';

  var wrap = document.getElementById('lkb-wrap');
  var bar = document.getElementById('lkb-bar');
  var xBtn = document.getElementById('lkb-x');
  var msg = document.getElementById('lkb-msg');
  var modal = document.getElementById('lkb-modal');
  var sheet = document.getElementById('lkb-sheet');
  if (!wrap || !bar || !modal) return;

  var GIFT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13M5 12v9h14v-9"/><path d="M12 8S9.5 3 7.5 3 4 5 5.5 6.5 12 8 12 8zM12 8s2.5-5 4.5-5S20 5 18.5 6.5 12 8 12 8z"/></svg>';

  var state = { subtotal: 0, won: [] };
  var TXT = CFG.badge || 'Faltam {valor} para desbloquear seu 1º brinde!';
  var TXT_PROX = CFG.badge_prox || 'Faltam {valor} para desbloquear o próximo brinde!';
  var TXT_OK = CFG.badge_ok || 'Seu brinde está liberado! Toque para ver';
  var SHOW_EMPTY = CFG.vazio !== false;
  var OFF_CART = CFG.off_cart !== false && /^\/cart(\/|$)/.test(location.pathname);
  var _fetch = window.fetch.bind(window);

  /* ---------- utils ---------- */
  function money(c) { return 'R$ ' + (c / 100).toFixed(2).replace('.', ','); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m];
    });
  }
  function getCart() {
    return _fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }
  function post(url, body) {
    return _fetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  function isGift(it) { return !!(it.properties && it.properties[PROP]); }
  function save(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function read(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }

  /* ---------- regra ---------- */
  function optedIn(t) { return AUTO || read('lkb_opt_' + t.product_id) === '1'; }
  function unlocked(sub) {
    var out = [], i;
    for (i = 0; i < TIERS.length; i++) if (sub >= TIERS[i].min) out.push(TIERS[i]);
    if (MODE === 'maior' && out.length) out = [out[out.length - 1]];
    return out;
  }
  function active(sub) { return unlocked(sub).filter(optedIn); }
  function chosenVariant(t) {
    var s = read('lkb_v_' + t.product_id), i;
    if (s) for (i = 0; i < t.variants.length; i++)
      if (String(t.variants[i].id) === s && t.variants[i].available) return t.variants[i].id;
    for (i = 0; i < t.variants.length; i++) if (t.variants[i].available) return t.variants[i].id;
    return t.variants[0].id;
  }
  function subtotalOf(cart) {
    var s = 0, it = cart.items || [], i;
    for (i = 0; i < it.length; i++) if (!isGift(it[i])) s += it[i].final_line_price;
    return s;
  }
  function progress(sub) {
    var n = TIERS.length, i, prev, frac;
    for (i = 0; i < n; i++) {
      if (sub < TIERS[i].min) {
        prev = i === 0 ? 0 : TIERS[i - 1].min;
        frac = (sub - prev) / (TIERS[i].min - prev);
        return ((i + Math.max(0, Math.min(1, frac))) / n) * 100;
      }
    }
    return 100;
  }

  /* ---------- sync ---------- */
  var busy = false, again = false, timer = null;
  function schedule(d) { clearTimeout(timer); timer = setTimeout(run, d == null ? 250 : d); }
  function run() {
    if (busy) { again = true; return; }
    busy = true;
    getCart().then(apply).catch(function () {}).then(function () {
      busy = false; if (again) { again = false; schedule(200); }
    });
  }

  function apply(cart) {
    var sub = subtotalOf(cart);
    var want = active(sub);
    var wantIds = want.map(chosenVariant);
    var updates = {}, changed = false, have = [], toAdd = [];

    (cart.items || []).forEach(function (it) {
      if (!isGift(it)) return;
      var keep = wantIds.indexOf(it.variant_id) > -1 && have.indexOf(it.variant_id) === -1;
      if (keep) { have.push(it.variant_id); if (it.quantity !== 1) { updates[it.key] = 1; changed = true; } }
      else { updates[it.key] = 0; changed = true; }
    });

    wantIds.forEach(function (id, i) {
      if (have.indexOf(id) === -1) {
        var p = {}; p[PROP] = want[i].title;
        toAdd.push({ id: id, quantity: 1, properties: p });
      }
    });

    render(sub, want);
    if (!changed && !toAdd.length) return;

    var chain = Promise.resolve();
    if (changed) chain = chain.then(function () { return post('/cart/update.js', { updates: updates }); });
    if (toAdd.length) chain = chain.then(function () { return post('/cart/add.js', { items: toAdd }); });

    return chain.then(getCart).then(function (c) {
      var s = subtotalOf(c); render(s, active(s)); notifyTheme();
    }).catch(function () {});
  }

  function notifyTheme() {
    ['cart:refresh', 'cart:updated', 'cart-drawer:refresh', 'lkb:changed'].forEach(function (n) {
      document.dispatchEvent(new CustomEvent(n, { bubbles: true, detail: { source: 'lk-brindes' } }));
    });
    if (/^\/cart(\/|$)/.test(location.pathname)) location.reload();
  }

  /* ---------- barra ---------- */
  var raf = null, pend = 0;
  function render(sub, won) {
    state.subtotal = sub; state.won = won || active(sub); pend = sub;
    if (raf) return;
    raf = requestAnimationFrame(function () {
      raf = null; paintBar(pend);
      if (modal.classList.contains('is-open')) paintSheet();
    });
  }

  function paintBar(sub) {
    var next = null, i, wonCount = 0;
    for (i = 0; i < TIERS.length; i++) { if (sub >= TIERS[i].min) wonCount++; }
    for (i = 0; i < TIERS.length; i++) if (sub < TIERS[i].min) { next = TIERS[i]; break; }

    if (OFF_CART) { wrap.classList.remove('is-mounted', 'is-on'); return; }
    wrap.classList.add('is-mounted');
    var hidden = (sub <= 0 && !SHOW_EMPTY) || dismissedAt() === String(wonCount);
    if (hidden) { wrap.classList.remove('is-on'); return; }
    wrap.classList.add('is-on');

    var base = next ? (sub >= TIERS[0].min ? TXT_PROX : TXT) : null;
    msg.innerHTML = next
      ? esc(base).replace('{valor}', '<b>' + money(next.min - sub) + '</b>')
      : esc(TXT_OK);
  }

  /* ---------- modal ---------- */
  function paintSheet() {
    var sub = state.subtotal, n = TIERS.length, i;
    var next = null;
    for (i = 0; i < n; i++) if (sub < TIERS[i].min) { next = TIERS[i]; break; }

    var h = '<div class="lkb-head"><div>' +
      '<h2 id="lkb-modal-title">' + esc(CFG.titulo || 'Brindes disponíveis') + '</h2>' +
      '<p>' + esc(CFG.subtitulo || '') + '</p></div>' +
      '<button type="button" class="lkb-close" data-lkb-close aria-label="Fechar">&times;</button></div>';

    h += '<p class="lkb-status">' + (next
      ? 'Faltam ' + money(next.min - sub) + ' para desbloquear o próximo brinde'
      : (MODE === 'maior' ? 'Parabéns, você liberou o melhor brinde!' : 'Parabéns, você conquistou todos os brindes!')) + '</p>';

    h += '<div class="lkb-rail"><div class="lkb-rtrack"><div class="lkb-rfill" style="transform:scaleX(' +
         (progress(sub) / 100).toFixed(3) + ')"></div></div><div class="lkb-marks">';
    TIERS.forEach(function (t, k) {
      var w = sub >= t.min;
      h += '<div class="lkb-mark' + (w ? ' is-won' : '') + '" style="left:' + (((k + 1) / n) * 100).toFixed(2) + '%">' +
             '<div class="lkb-dot">' + GIFT + '</div>' +
             '<p class="lkb-mlabel">' + money(t.min).replace(',00', '') + '</p>' +
           '</div>';
    });
    h += '</div></div><div class="lkb-sep"></div><div class="lkb-grid">';

    TIERS.forEach(function (t) {
      var w = sub >= t.min;
      var inCart = state.won.indexOf(t) > -1;
      var cls = 'lkb-card' + (inCart ? ' is-won' : (w ? ' is-open' : ' is-locked'));
      var label, act = '';
      if (inCart) label = 'Selecionado!';
      else if (w) {
        if (MODE === 'maior') label = 'Trocado pelo maior';
        else if (AUTO) label = 'Liberado';
        else { label = 'Receber brinde'; act = ' data-lkb-get="' + t.product_id + '"'; }
      }
      else label = 'Faltam ' + money(t.min - sub).replace(',00', '');

      h += '<div><p class="lkb-col-label"><span class="lkb-lbl-full">Por ' + money(t.min) + ' ganhe esse brinde</span>' +
             '<span class="lkb-lbl-short">' + money(t.min).replace(',00', '') + '</span></p>' +
             '<div class="' + cls + '"><span class="lkb-picwrap">' +
               (t.image ? '<img class="lkb-pic" src="' + esc(t.image) + '" alt="' + esc(t.title) + '" loading="lazy" decoding="async">' : '<span class="lkb-pic"></span>') +
               '<p class="lkb-name">' + esc(t.title) + '</p></span>';

      var opts = t.variants.filter(function (v) { return v.available; });
      if (inCart && opts.length > 1) {
        var cur = String(chosenVariant(t));
        h += '<select class="lkb-select" data-lkb-variant="' + t.product_id + '">';
        opts.forEach(function (v) {
          h += '<option value="' + v.id + '"' + (String(v.id) === cur ? ' selected' : '') + '>' + esc(v.title) + '</option>';
        });
        h += '</select>';
      }

      h += '<button type="button" class="lkb-btn"' + act + (w && !inCart && !AUTO ? '' : ' disabled') + '>' + label + '</button>' +
           '</div></div>';
    });

    h += '</div>';
    if (AVISO && MODE === 'maior') {
      h += '<div class="lkb-alert"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
           '<circle cx="12" cy="12" r="9"/><path d="M12 8h.01M11 12h1v4h1"/></svg><span>' + esc(AVISO) + '</span></div>';
    }
    if (CFG.rodape) h += '<p class="lkb-foot">' + esc(CFG.rodape) + '</p>';
    sheet.innerHTML = h;
  }

  function openModal() {
    paintSheet();
    modal.hidden = false; modal.classList.add('is-open');
    bar.setAttribute('aria-expanded', 'true');
    document.documentElement.style.overflow = 'hidden';
    var c = sheet.querySelector('[data-lkb-close]'); if (c) c.focus();
  }
  function closeModal() {
    modal.classList.remove('is-open'); modal.hidden = true;
    bar.setAttribute('aria-expanded', 'false');
    document.documentElement.style.overflow = '';
    bar.focus();
  }

  function dismissedAt() { try { return sessionStorage.getItem('lkb_hide'); } catch (e) { return null; } }

  bar.addEventListener('click', openModal);
  if (xBtn) xBtn.addEventListener('click', function (e) {
    e.stopPropagation();
    var n = 0;
    for (var i = 0; i < TIERS.length; i++) if (state.subtotal >= TIERS[i].min) n++;
    try { sessionStorage.setItem('lkb_hide', String(n)); } catch (err) {}
    wrap.classList.remove('is-on');
  });
  modal.addEventListener('click', function (e) {
    if (e.target === modal || e.target.closest('[data-lkb-close]')) { closeModal(); return; }
    var g = e.target.closest('[data-lkb-get]');
    if (g) { save('lkb_opt_' + g.getAttribute('data-lkb-get'), '1'); schedule(0); }
  });
  modal.addEventListener('change', function (e) {
    var s = e.target.closest('[data-lkb-variant]');
    if (!s) return;
    save('lkb_v_' + s.getAttribute('data-lkb-variant'), s.value);
    schedule(0);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
  }, { passive: true });

  /* ---------- detecção de mudança no carrinho ---------- */
  var RX = /\/cart\/(add|change|update|clear)/;
  window.fetch = function () {
    var out = _fetch.apply(null, arguments);
    try {
      var a = arguments[0], url = typeof a === 'string' ? a : (a && a.url) || '';
      if (RX.test(url)) out.then(function () { schedule(); }).catch(function () {});
    } catch (e) {}
    return out;
  };
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) {
    try { if (RX.test(String(u))) this.addEventListener('load', function () { schedule(); }, { passive: true }); } catch (e) {}
    return _open.apply(this, arguments);
  };
  ['cart:updated', 'cart:refresh', 'cart:build'].forEach(function (n) {
    document.addEventListener(n, function (e) {
      if (e.detail && e.detail.source === 'lk-brindes') return;
      schedule(400);
    }, { passive: true });
  });
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) schedule(600);
  }, { passive: true });

  if (window.requestIdleCallback) requestIdleCallback(function () { run(); }, { timeout: 2500 });
  else setTimeout(run, 1000);
})();